import React, { useEffect, useState, useRef } from "react";
import { Animated, Platform, StyleSheet, View, AppState } from "react-native";
import { ColorTokens, CreditLoadingPageType, FontFamilyTokens, FontSizeTokens, LottieSizeTokens, LottieTokens, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import { Lottie } from "../../lottie/Lottie";
import { Typography } from "../../typography/Typography";
import { addCommasToNumber, getLenderIcon, isFromTDLPlatform } from "../utils";
import { Icon } from "../../icon/Icon";
import LottieView from "lottie-react-native";
import { isFontMobile } from "../../stack/utils";
// import LottieView from "lottie-react-native";
const CreditLoading = ({ height, triggerAction, helpAction, isSuccessful, continueAction, availableCreditLimitAmount, lenderData, type, showNewCongratsScreenForAll, isPrimaryApplication, }) => {
    const [SlideInLeft1, setSlideInLeft1] = useState(new Animated.Value(1));
    const [SlideInLeft2, setSlideInLeft2] = useState(new Animated.Value(0));
    const availableCredLimit = isNaN(Number(availableCreditLimitAmount)) ? "Unavailable" : `${addCommasToNumber(Number(availableCreditLimitAmount))}`;
    const [_lenderData, setLenderData] = useState(lenderData);
    const [hourGlassLottie, setHourGlassLottie] = useState("");
    const [isLottieLoaded, setisLottieLoaded] = useState(false);
    const isCibilOrCheckElibility = (type) => {
        return (type === CreditLoadingPageType.CHECK_ELIGIBILITY
            || type === CreditLoadingPageType.CIBIL);
    };
    const [appState, setAppState] = useState(AppState.currentState);
    const animationRef = useRef(null);
    useEffect(() => {
        const handleAppStateChange = (nextAppState) => {
            if (appState.match(/inactive|background/) && nextAppState === 'active') {
                if (animationRef.current) {
                    animationRef.current.play();
                }
            }
            setAppState(nextAppState);
        };
        // Add the event listener when the component mounts
        AppState.addEventListener('change', handleAppStateChange);
        // Remove the event listener when the component unmounts
        return () => {
            //@ts-ignore
        };
    }, [appState]);
    useEffect(() => {
        if (isFromTDLPlatform()) {
            fetch("https://lottie.host/f5634667-3816-40a0-8af8-470ebefaafdc/zi1HcVnmgP.json", {
                method: "GET",
            })
                .then((response) => response.json())
                .then((responseData) => {
                console.log(responseData);
                setisLottieLoaded(true);
                setHourGlassLottie(responseData);
            })
                .catch((error) => {
                console.log(error);
            });
        }
    }, []);
    useEffect(() => {
        if (isSuccessful) {
            Animated.parallel([
                Animated.timing(SlideInLeft1, {
                    toValue: 0,
                    duration: 500,
                    useNativeDriver: false,
                }),
                Animated.timing(SlideInLeft2, {
                    toValue: 1,
                    duration: 1000,
                    useNativeDriver: false,
                }),
            ]).start();
            setTimeout(() => {
                triggerAction({
                    ...continueAction
                });
            }, 4000);
        }
    }, [isSuccessful]);
    const creditApprovedWithAnimation = () => {
        return (React.createElement(Animated.View, { style: {
                opacity: SlideInLeft2,
                flex: 1,
                width: '100%',
                backgroundColor: "white",
                justifyContent: "center"
            } }, (showNewCongratsScreenForAll && !isPrimaryApplication) ? newCreditApprovedScreen() : creditApproved()));
    };
    const newCreditApprovedScreen = () => {
        return (React.createElement(View, null,
            React.createElement(View, { style: { height: height - 60, padding: 16, alignItems: 'center' } },
                React.createElement(View, { style: { marginTop: 96, alignItems: 'center', marginBottom: 32 } },
                    React.createElement(Lottie, { uri: LottieTokens.Enhance_Limit_Success, size: LottieSizeTokens.Size_96 })),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H2B, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins, label: "Congratulations!", textAlign: TextAlignTokens.center }),
                React.createElement(View, { style: { marginTop: 4 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0M, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter, label: "Available limit increased successfully", textAlign: TextAlignTokens.center })),
                React.createElement(View, { style: { marginTop: 32, flexDirection: 'row', alignItems: 'center' } },
                    React.createElement(Typography, { label: `+ ₹`, fontWeight: '700', color: ColorTokens.Secondary_100, fontSize: isFontMobile() ? FontSizeTokens.XXXXL : FontSizeTokens.XXL, lineHeight: isFontMobile() ? 40 : 32 }),
                    React.createElement(View, { style: { top: Platform.OS === 'ios' ? 2 : 0 } },
                        React.createElement(Typography, { label: `${availableCredLimit}`, typeDLS: TypographyTypeDLS.H1B, color: ColorTokens.Secondary_100 }))),
                React.createElement(View, { style: { position: 'absolute', justifyContent: 'center', alignItems: 'center' } }, Platform.OS === 'ios' ?
                    React.createElement(LottieView, { ref: animationRef, source: { uri: "https://lottie.host/19405fb0-a051-4310-8f30-53992f37447c/Bdx1gocQfp.json" }, style: { width: '100%', height: 'auto', flex: 1 }, autoPlay: true, loop: false }) :
                    React.createElement(Lottie, { uri: LottieTokens.UnlockNew, size: LottieSizeTokens.FULL, autoplay: true, loop: false }))),
            React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center' } },
                React.createElement(View, { style: { marginRight: 9 } },
                    React.createElement(Typography, { label: 'Lending partner', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, fontWeight: '400', color: ColorTokens.Grey_Charcoal, lineHeight: 16 })),
                React.createElement(View, { style: { marginLeft: _lenderData?.lenderAccountId === "DSP" ? -62 : 0 } },
                    React.createElement(Icon, { name: getLenderIcon(_lenderData?.lenderAccountId) })))));
    };
    const creditApproved = () => {
        return (React.createElement(View, { style: { height: height - 18, padding: 16 } },
            React.createElement(View, { style: {
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    flexDirection: 'column',
                    flex: 1,
                } },
                React.createElement(Typography, { fontWeight: "600", fontSize: FontSizeTokens.XL, lineHeight: 28, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins, label: "Congratulations!", textAlign: TextAlignTokens.center }),
                React.createElement(View, { style: { marginTop: 4 } },
                    React.createElement(Typography, { fontWeight: "400", fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter, label: "Your account has been\nsuccessfully opened", textAlign: TextAlignTokens.center })),
                React.createElement(View, { style: {
                        padding: 16,
                        width: "100%",
                        marginTop: 24,
                        marginRight: 8,
                        marginLeft: 8,
                        borderRadius: 16,
                        shadowColor: "rgba(12, 25, 86, 0.08)",
                        shadowOffset: {
                            width: 0,
                            height: 20,
                        },
                        shadowRadius: 40,
                        elevation: 40,
                        shadowOpacity: 1,
                        borderStyle: "solid",
                        borderColor: "#f1f3f5",
                        borderWidth: 1,
                        left: 0,
                        top: 0,
                        backgroundColor: "#fff",
                    } },
                    React.createElement(Typography, { fontWeight: "400", fontSize: FontSizeTokens.XS, lineHeight: 18, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter, label: "Available cash" }),
                    React.createElement(View, { style: { marginTop: 4, flexDirection: 'row' } },
                        React.createElement(Typography, { fontWeight: "900", fontSize: FontSizeTokens.XXXXL, lineHeight: 40, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter, label: '₹' }),
                        React.createElement(Typography, { fontWeight: "900", fontSize: FontSizeTokens.XXXXL, lineHeight: 40, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins, label: `${availableCredLimit}` })),
                    React.createElement(View, { style: { justifyContent: 'flex-end', marginTop: 50 } },
                        React.createElement(Typography, { fontSize: FontSizeTokens.XXS, fontFamily: FontFamilyTokens.Inter, fontWeight: "400", lineHeight: 16, color: ColorTokens.Grey_Charcoal, label: "100% of total limit available" }),
                        React.createElement(View, { style: {
                                height: 6,
                                width: '100%',
                                backgroundColor: "#109648",
                                marginTop: 4,
                                borderRadius: 8
                            } }))),
                React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginTop: 24 } },
                    React.createElement(View, { style: { marginRight: 9 } },
                        React.createElement(Typography, { label: 'Lending partner', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, fontWeight: '400', color: ColorTokens.Grey_Charcoal, lineHeight: 16 })),
                    React.createElement(View, { style: { marginLeft: _lenderData?.lenderAccountId === "DSP" ? -62 : 0 } },
                        React.createElement(Icon, { name: getLenderIcon(_lenderData?.lenderAccountId) })))),
            React.createElement(View, { style: styles.overlay }, Platform.OS === 'ios' ?
                React.createElement(LottieView, { ref: animationRef, source: { uri: "https://lottie.host/19405fb0-a051-4310-8f30-53992f37447c/Bdx1gocQfp.json" }, style: { width: '100%', height: 'auto', flex: 1 }, autoPlay: true, loop: false }) :
                isLottieLoaded && React.createElement(LottieView, { source: hourGlassLottie, style: { width: 100, height: 100 }, autoPlay: true, loop: true }))));
    };
    const creditStatusLoading = () => {
        return (React.createElement(Animated.View, { style: {
                opacity: SlideInLeft1,
                flex: 1,
                height: height - 90,
                width: '100%',
                backgroundColor: "white",
                justifyContent: "center"
            } },
            React.createElement(View, { style: { height: Platform.OS !== 'web' ? height - 60 : height - 114, padding: 16 } },
                React.createElement(View, { style: styles.bodyContainer },
                    Platform.OS === 'ios' ?
                        React.createElement(React.Fragment, null,
                            React.createElement(LottieView, { ref: animationRef, source: { uri: "https://lottie.host/ce1a5285-9074-4316-871b-081377ea1b24/4nfIbLjIMG.json" }, style: { width: 128, height: 128 }, autoPlay: true, loop: true }))
                        :
                            isLottieLoaded && isFromTDLPlatform() ? React.createElement(LottieView, { source: hourGlassLottie, style: { width: 100, height: 100 }, autoPlay: true, loop: true }) : React.createElement(React.Fragment, null,
                                React.createElement(Lottie, { uri: LottieTokens.SandTimer, size: LottieSizeTokens.XXL })),
                    React.createElement(Typography, { label: !isCibilOrCheckElibility(type)
                            ? "You're just a step away! Getting your account ready."
                            : "Verifying your details...", color: ColorTokens.Grey_Night, lineHeight: 24, fontWeight: "600", fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Poppins, textAlign: TextAlignTokens.center }),
                    React.createElement(View, { style: { marginTop: 8 } },
                        React.createElement(Typography, { label: !isCibilOrCheckElibility(type)
                                ? "It may take 10-15 Seconds..."
                                : "It may take up to 30 seconds...", fontFamily: FontFamilyTokens.Inter, lineHeight: 20, fontWeight: "400", fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center }))))));
    };
    return isSuccessful ? creditApprovedWithAnimation() : creditStatusLoading();
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    bodyContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        flexDirection: 'column',
        flex: 1,
        padding: 8
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
    },
});
// @ts-ignore
export default (CreditLoading);
